import { cn } from '@/lib/utils'
import { Button, Container, Section, Title } from '@/ui/components'
import { memo } from 'react'
import { ButtonProps } from '../Button/type'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  description: string
  button: ButtonProps
  wrapper?: boolean
  className?: string
  ref?: React.RefObject<HTMLDivElement>
}

const Content = ({
  title,
  description,
  button,
  className,
  ...props
}: Props) => (
  <div
    className={cn(
      'px-padding-md py-4xl gap-2xl col-span-12 flex flex-col bg-neutral-200',
      className
    )}
    {...props}
  >
    <div className="">
      <Title as="h2" className="display text-accent-300">
        {title}
      </Title>
      <Title as="h3" className="h2 text-neutral">
        {description}
      </Title>
    </div>
    <div>
      <Button {...button} />
    </div>
  </div>
)

const NoResults = ({
  title,
  description,
  button,
  wrapper = false,
  className,
  ...props
}: Props) => {
  if (wrapper) {
    return (
      <Section>
        <Container>
          <Content
            title={title}
            description={description}
            button={button}
            className={className}
            {...props}
          />
        </Container>
      </Section>
    )
  } else {
    return (
      <Content
        title={title}
        description={description}
        button={button}
        className={className}
        {...props}
      />
    )
  }
}

export default memo(NoResults)
